import { useCallback, useState } from 'react'

import { api } from 'app/api'
import { ParamsPUT } from 'app/common/types/food/schools/complexes/sort'

import {
  PUT_COMPLEXES_SORT,
  convertParams,
  convertResult,
} from 'app/common/api/requests/food/schools/complexes/sort/put'

export const useComplexesSortMutate = () => {
  const [pending, setPending] = useState<boolean>(false)

  const submit = useCallback(async (params: ParamsPUT) => {
    setPending(true)

    const res = await api.request(PUT_COMPLEXES_SORT, {
      error: 'Не удалось обновить сортировку комплектов',
      params,
      convertions: {
        convertParams,
        convertResult,
      },
    })
    setPending(false)
    if (res) {
      return true
    }
    return false
  }, [])

  return {
    pending,
    submit,
  }
}
